<template>
<div id="container" class="container geschichte_200601">
  <div class="fullscreen_background">
    <img src="/static/assets/geschichte_200601/Hintergrund_2860.png" />
  </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
  <div class="spotlight1">
   <!-- <img class="img" src="/static/assets/geschichte_200601/Zirkusdirektor_Dubix_2880zu1620_02-01.png" />-->
  </div>
	<div class="spotlight2">
    <img class="img" src="/static/assets/geschichte_200601/Schein_Unsichtbares_Alien.png" />
  </div>
	<div class="spotlight3">
    <img class="img" src="/static/assets/geschichte_200601/Schein_Kopie.png" />
  </div>
  <div class="gigi z30">
    <img class="img" src="/static/assets/geschichte_200601/Unsichtbares_Alien_BITTE_SCHWEBEN_LASSEN.png" class="hovering"/>
  </div>
  <div class="libero z30"><img class="img" src="/static/assets/geschichte_200601/Sandwich_anim_2.png" /></div>
  <div class="trompeter z30">
    <img class="img" src="/static/assets/geschichte_200601/Hugi_Harry.png" />
  </div>
  <div class="hugi z30"><img class="img" src="/static/assets/geschichte_200601/Gigi_Nanni.png" /></div>
  <div class="dubix z30">
    <img class="img " src="/static/assets/geschichte_200601/Dubix_Joe.png" />
  </div>
  <div class="zampana z30">
    <img class="img " src="/static/assets/geschichte_200601/Blubber_anim_neu.png" />
  </div>
  <!-- <div class="moebel_vorne z40">
        <img class="img" src="/static/assets/geschichte_200601/Moebel_vorne.png" />
    </div> -->

  <!-- <router-link to="/maerchengeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/geschichte_200601/Pfeil.png" />
    </router-link> -->
  <!--div class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/geschichte_200601/Pfeil-1.png" />
    </div-->

  <router-link to="/geschichte_200603" tag="div" class="pfeil_links_big z50 pointer">
    <img class="img" src="/static/assets/alle/Pfeil.png" />
  </router-link>
  <router-link tag="div" to="geschichte_200602" class="pfeil_rechts_big z50 pointer">
    <img class="img" src="/static/assets/alle/Pfeil-1.png" />
  </router-link>

  <div class="geschichte z45">
    <div class="inner">
      <img src="/static/assets/geschichte_200601/Textfeld.png" usemap="#geschichte-map">
      <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_1_Gigi_Nanni.mp3" jsonurl="/static/assets/geschichten/gigi_ausgabe_5.json" content=".geschichte_200601" target="geschichte_200601_target" />
      <vuescrollbar tag="div" class="fliesstext" id="geschichte_200601_target">
        <p>Eigentlich war Burg Buchstein ein ganz normales Internat. Bis zu dem Tag, an dem die Aliens kamen. Und das geschah so: Eines Nachts, Dubix Joe, Hugi Harry und Gigi Nanni hatten sich gerade zu einer geheimen Mitternachtsparty im Internatspark getroffen, landete da ein Ufo. Ja, wirklich! Aufgeregt versteckten sich die drei hinter einer Hecke. Grell blinkend öffnete das Ufo seine Tür und zwei – oder waren es drei? – merkwürdige Gestalten stiegen aus und verschwanden im Internatsgebäude. Das Ufo flog wieder davon. Was sollten die drei jetzt tun? Die Aliens suchen? Wenn sie berichteten, was sie gesehen haben, würde es ihnen niemand glauben. Noch dazu müssten sie dann zugeben, das Internat nachts verlassen zu haben. Was absolut verboten war. Besser, sie sagten nichts und warteten ab. </p>
<p>Am nächsten Morgen saßen sie im Klassenzimmer. Frau Eisenbeiß stand an der Tafel und erklärte, warum man Vater nur mit einem und Mutter mit zwei „t“ schreibe. Dubix Joe blickte gelangweilt zu Hugi Harry, der nervös auf den Boden zeigte. Merkwürdig! Seine Schultasche bewegte sich, als ob sie tief ein- und ausatmete. Buff! Jetzt schien sie zu explodieren. Eine blitzblaue, schleimige Masse flog durch die Luft und landete – platsch!!! – auf Frau Eisenbeiß’ Föhnfrisur. Die schrie und stammelte: „Wer war …?“, als die Masse auf ihrem Kopf die Form einer Kaugummiblase annahm, Grimassen schnitt und blubberte: „Bibltk, bibltk, bibltk.“ Frau Eisenbeiß erstarrte vor Schreck, die Klasse hielt sich die Bäuche vor Lachen. Jetzt schrieb eine unsichtbare Hand langsam, mit unerträglich quietschender Kreide „SER-54-1“ an die Tafel. Das war ganz schön gruselig, die Klasse verstummte, Frau Eisenbeiß setzte sich und fiel in Ohnmacht. Da begann ein Schüler vor Angst zu schluchzen.</p>
<p>Hugi Harry fand, er müsse alles erklären, stellte sich mit Dubix Joe vor die Tafel und rief: „Hey, keine Panik! Das sind nur ein paar Außerirdische, die gestern Nacht hier gelandet sind.“ In der Klasse erhob sich ein Riesentumult. Denn das aufgedruckte Alien auf Dubix Joes Pulli wurde lebendig, sprang aus dem Pulli heraus und stellte sich zwischen Dubix Joe und Hugi Harry. Libero Alpha war ein kleines Wesen, voller weißer Haare, mit großen Augen, die teleskopartig über der Stirn wippten, und gewaltigen Ohren, mit denen es Dubix Joe und Hugi Harry umarmte, also eigentlich umohrte. </p>
<p>Plötzlich wurde die Türe aufgerissen und Libero Alpha verschwand wieder im Pulli. Rektor Rot betrat den Raum und erkundigte sich genervt: „Kollegin Eisenbeiß, haben Sie Ihre Klasse etwa nicht im Griff? Was für ein Lärm!“ Frau Eisenbeiß, aus ihrer Ohnmacht erwacht, zeigte auf Dubix Joe und Hugi Harry und antwortete: „Doch, doch, die beiden tragen uns gerade Gedichte vor, lustige Gedichte.“ „So, so!“, sagte Rektor Rot und blickte ungläubig auf das schleimige, blaue Kunsthaar, das Frau Eisenbeiß heute trug, „Na dann, macht weiter!“, befahl er und verließ den Klassenraum. Da stieg Libero Alpha wieder aus dem Pulli, umohrte Hugi Harry und Dubix Joe und versuchte sie mit sich zu ziehen. Die entsetzte Frau Eisenbeiß fiel erneut in Ohnmacht. „Ich hab’s!“ rief plötzlich Gigi Nanni. „Die wollen in die Bibliothek!“ „Bibltk“, blubberte es. „Das an der Tafel ist eine Signatur für ein Buch: Serie 54, Band 1!“ Nun begann leise, leise eine Prozession zur Internatsbibliothek. Vorneweg die drei Freunde mit Libero Alpha, dahinter, getragen von ihrer Klasse, die ohnmächtige Frau Eisenbeiß samt Blubber-Alien und ganz am Ende schwebte ein Stück Kreide. Gigi Nanni fand schnell das gewünschte Buch und überreichte es Libero Alpha. „Vier Wochen Ausleihfrist“, sagte sie streng, „dann müsst ihr es wiederbringen.“ „Jjjjj“, blubberte das Blubber-Alien. So kam es, dass alle vier Wochen im Park des Internats ein Ufo landete und die Aliens, die alle Bücher ihres Sterns schon gelesen hatten, sich neuen Lesestoff ausliehen. Diesem einmaligen interstellaren Buchaustauschprogramm gab man das unvergessliche Motto:</p>
        <p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
  </div>

</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Copyright from '@/components/Copyright.vue'
import Snowf from 'vue-snowf'
import Lautsprecher from '@/components/Lautsprecher.vue'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'geschichte_200601',
  data () {
    return {
      who: 'geschichte_200601',
      sternchen: '/static/assets/geschichte_200601/sternchen.png',
      audioposition: 0
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright, 
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () { 
    this.$ga.page(this.$router)
    var self = this
    setTimeout(function () {
      var muted = (typeof self.$root.muted !== 'undefined' ? self.$root.muted : false)
      try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      window.currentAudioX = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Gigi_Titel_Gigi_Nanni.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }

      window.hintergrundSound = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Gigi_Nanni_Atmo_IIb.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined'?   window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e) {
        window.bgsounddisabled = true
      }


    }, 1000);
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }

  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/* geschichte_200601 */

.geschichte_200601 {
  position: absolute;
  width: 1920px;
  height: 1080px;
  top: 0;
}

.geschichte_200601 .himmel {
  display: block !important;
}

.geschichte_200601 .geschichte {
  position: absolute;
    top: 144px;
    left: 50%;
}

.geschichte_200601 .geschichte .inner {
  position: relative;
}



.geschichte_200601 .pfeil_links_big {
  position: absolute;
  left: 1vw;
  top: 40%;
}

.geschichte_200601 .pfeil_rechts_big {
  position: absolute;
  right: 1vw;
  top: 40%;
}

.geschichte_200601 .moebel_vorne {
  position: absolute;
  bottom: 0;
  left: 0;
}

.geschichte_200601 .miss_witch {
  position: absolute;
  /* top: 50%; left: 21%; */
  top: 47%;
  left: 23%;
}

.geschichte_200601 .hugi {
  position: absolute;
  opacity:0;
  animation: hugi_erscheint 1s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes hugi_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.geschichte_200601 .jongleur {
  opacity:0;
  animation: jongleur_erscheint 1.5s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes jongleur_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
	.geschichte_200601 .trompeter {
  opacity:0;
  animation: trompeter_erscheint 2s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}
@-webkit-keyframes wippen /* Safari and Chrome */ {
  0% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  25% {
    -webkit-transform: rotateX(15deg);
    -o-transform: rotateX(15deg);
    transform: rotateX(15deg);
  }
  50% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  75% {
    -webkit-transform: rotateX(-15deg);
    -o-transform: rotateX(-15deg);
    transform: rotateX(-15deg);
  }
  100% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
}
@keyframes wippen {
  0% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  25% {
    -webkit-transform: rotateX(15deg);
    -o-transform: rotateX(15deg);
    -moz-transform: rotateX(15deg);
    transform: rotateX(15deg);
  }
  50% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  75% {
    -webkit-transform: rotateX(-15deg);
    -o-transform: rotateX(-15deg);
    -moz-transform: rotateX(-15deg);
    transform: rotateX(-15deg);
  }
  100% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
}
.geschichte_200601 .spotlight1 img{animation: spotlight1_erscheint 3s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight1_erscheint {
    0% {margin-left: 1000px; opacity:0;}
    50% { opacity:0.5;}
    100% {margin-left: 0px; opacity:1;}
}
	.geschichte_200601 .spotlight2 img{animation: spotlight2_erscheint 3s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight2_erscheint {
    0% {margin-top: -250px; opacity:0;}
    100% {margin-top: 0px; opacity:0.75;}
}
		.geschichte_200601 .spotlight3 img{animation: spotlight3_erscheint 2s ease-out; animation-delay: 3s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight3_erscheint {
    0% {margin-top: -250px; opacity:0;}
    100% {margin-top: 0px; opacity:0.75;}
}
.geschichte_200601 .wippen {
  -webkit-animation: wippen 4s linear infinite;
  -moz-animation: wippen 4s linear infinite;
  -ms-animation: wippen 4s linear infinite;
  -o-animation: wippen 4s linear infinite;
  animation: wippen 4s linear infinite;
}
@keyframes trompeter_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.geschichte_200601 .libero {
  position: absolute;
    top: -270px;
    left: -480px;
}

.geschichte_200601 .libero {
  animation: libero_erscheint 0.5s ease-out;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes libero_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.geschichte_200601 .zampano {
  position: absolute;
    top: 369px;
    left: 784px;
}

.geschichte_200601 .zampano img {
  animation-delay: 8s;
  animation: zampano_erscheint 1s;
  transform-origin: bottom center;
}

@keyframes zampano_erscheint {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  80% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.geschichte_200601 .fliesstext {
  bottom: 28%;
  left: 9.5%;
  width: 79%;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 450px;
  padding-right: 15px;
}

.geschichte_200601 div.fliesstext>span {
  margin-right: 8px !important;
  float: left !important;
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #ac8a69;
  box-shadow: inset 0 0 0px #ac8a69;
  -webkit-border-radius: 0;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #ac8a69;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #ac8a69;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

::-webkit-scrollbar-button:vertical:decrement {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_up.png);
  background-position: 0px 0px;
}

::-webkit-scrollbar-button:vertical:increment {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_do.png);
  background-position: 0px 0px;
}

.snowf-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 150% !important;
  height: 150% !important;
  left: -25% !important;
  z-index: 30 !important;
}

.dubix_animation {
  width: 320px;
  height: 320px;
  background: url('/static/assets/geschichte_200601/01_zirkusmeister_Dubix.png') top center;
  transform: scale(1);
  margin-top: -25px;
  margin-left: -50px;
}
.geschichte_200601 .gigi {
    position: absolute;
  top: 360px;
    left: 250px;
    opacity: 0;
    animation: gigi_erscheint 3s ;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
}

@keyframes gigi_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes play_dubix {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -1600px;
  }
  100% {
    background-position: 0 -1600px;
  }
}

.globus {
  width: 350px;
  height: 350px;
  background: url('/static/assets/geschichte_200601/01_Globus_1.png') top center;
  animation-delay: 2s;
  animation: play_globus 4s steps(6) infinite;
  transform: scale(0.465);
  top: -87px;
  left: 849px;
  position: absolute;
}

@keyframes play_globus {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -2100px;
  }
  100% {
    background-position: 0 -2100px;
  }
}
.kerze {
    width: 380px;
    height: 529px;
    background: url(/static/assets/geschichte_200601/01_Kerze_1.png) top center;
    animation: play_kerze 2s steps(8) infinite;
    transform: scale(0.26);
    top: 533px;
    left: 728px;
    position: absolute;
}

@keyframes play_kerze {
  0% {
    background-position: 0 0px;
  }
  100% {
    background-position: 0 -4232px;
  }
}
.dubix.z30 {
  position: absolute;
    top: 514px;
    left: 619px;
    animation: dubix_erscheint 1s ;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
  opacity: 0;
}

@keyframes dubix_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.geschichte_200601 .hugi {
    position: absolute;
top: 330px;
    left: 474px;
}
	.geschichte_200601 .jongleur {
    position: absolute;
    top: 465px;
    left: 380px;
}
.geschichte_200601 .trompeter {
    position: absolute;
top: 712px;
    left: 399px;
}
.geschichte_200601 .spotlight1, .geschichte_200601 .spotlight2 {
    position: absolute;
    top: -130px;
    left: 850px;
} 
.geschichte_200601 .spotlight3 {
    position: absolute;
    top: 0px;
    left: 290px;
}
	.geschichte_200601 .zampana {
    position: absolute;
    top: -280px;
    left: -450px;
}
.dubix {
  transform-origin: bottom center;
}


@keyframes jongleur_animation {
  100% {
    background-position: 0 -1760px;
  }
}
	.zampano_animation {
  width: 610px;
  height: 682px;
  background: url('/static/assets/geschichte_200601/zampano_animation.png') top center;
  animation-delay: 2s;
  animation: zampano_animation 3s steps(10) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes zampano_animation {
  100% {
    background-position: 0 -6820px;
  }
}
.hovering {
  -webkit-animation: hovering 8s ease-in-out infinite;
  -moz-animation: hovering 8s ease-in-out infinite;
  -ms-animation: hovering 8s ease-in-out infinite;
  -o-animation: hovering 8s ease-in-out infinite;
  animation: hovering 8s ease-in-out infinite;
}

@-webkit-keyframes hovering
/* Safari and Chrome */

  {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes hovering {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  /* 25% {
    -ms-transform: translate(-20px,20px);
    -moz-transform: translate(-20px,20px);
    -webkit-transform: translate(-20px,20px);
    -o-transform: translate(-20px,20px);
    transform: translate(-20px,20px);
  }
 */
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  /*  75% {

    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
*/
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

span {
  font-family: FrozenMemory;
}
</style>



// WEBPACK FOOTER //
// src/components/Geschichte_200601.vue